





















































































































































































import { Vue, Component, Watch } from "vue-property-decorator";
import PrivacyDialog from "../components/Dialogs/PrivacyDialog.vue";
import SignUpText from "../components/SignUp/SignUpText.vue";
import { bus } from "../main";

@Component({
  components: {
    PrivacyDialog,
    SignUpText
  }
})
export default class SignUp extends Vue {
  private dialog: boolean;

  private show1: boolean;
  private nomeAzienda: string;
  private indirizzoAzienda: string;
  private comuneAzienda: string;
  private capComuneAzienda: string;
  private nazioneAzienda: string;
  private pIva: string;
  private telefonoAzienda: string;
  private emailAzienda: string;
  private password: string;
  private confPassword: string;
  private nomeAziendaRules: [boolean | string];
  // private comuneAziendaRules: [boolean | string];
  private emailAziendaRules: [boolean | string];
  private telRules: [boolean | string];
  private passwordRules: [boolean | string];
  private pIvaRules: [boolean | string];

  constructor() {
    super();
    this.show1 = false;
    this.nomeAzienda = "";
    this.indirizzoAzienda = "";
    this.comuneAzienda = "";
    this.capComuneAzienda = "";
    this.nazioneAzienda = "";
    this.pIva = "";
    this.telefonoAzienda = "";
    this.emailAzienda = "";
    this.password = "";
    this.confPassword = "";
    this.nomeAziendaRules = [true];
    // this.comuneAziendaRules = ["Comune Azienda necessario"];
    this.emailAziendaRules = [true];
    this.telRules = [true];
    this.passwordRules = [true];
    this.pIvaRules = [true];

    this.dialog = false;
  }

  @Watch("pIva")
  onPivaChange(value: string) {
    this.pIva = value.toUpperCase();
  }

  get pswMatchRules() {
    var rules: [boolean | string] = [false];
    if (this.password) {
      if (this.password === this.confPassword) {
        rules = [true];
      } else {
        rules = ["I valori delle password non combaciano"];
      }
    }
    return rules;
  }

  validazioneNomeAzienda() {
    var valid: boolean = false;
    if (this.nomeAzienda !== "") {
      valid = /^[a-zA-Z0-9ìèéùòà'&.\x20/-]{2,50}$/.test(this.nomeAzienda);
    }
    if (valid) {
      this.nomeAziendaRules = [true];
    } else if (this.nomeAzienda === "") {
      this.nomeAziendaRules = ["Denominazione Azienda necessaria"];
    } else {
      this.nomeAziendaRules = [
        "Denominazione Azienda deve essere compresa tra i 2 e i 50 caratteri"
      ];
    }
  }
  // validazioneComuneAzienda() {
  //   var valid: boolean = false;
  //   if (this.comuneAzienda !== "") {
  //     valid = /^[a-zA-Z]{2,50}$/.test(this.comuneAzienda);
  //   }
  //   if (valid) {
  //     this.comuneAziendaRules = [true];
  //   } else if (this.comuneAzienda === "") {
  //     this.comuneAziendaRules = ["Comune Azienda necessario"];
  //   } else {
  //     this.comuneAziendaRules = [
  //       "Comune Azienda deve essere compreso tra i 2 e i 50 caratteri"
  //     ];
  //   }
  // }
  validazioneEmailAzienda() {
    var valid: boolean = false;
    if (this.emailAzienda !== "") {
      valid = /[a-zA-Z0-9._&-]+@[a-zA-Z0-9._&-]+\.[a-z]{2,}$/.test(
        this.emailAzienda
      );
    }
    if (valid) {
      this.emailAziendaRules = [true];
    } else if (this.emailAzienda === "") {
      this.emailAziendaRules = ["Email Azienda necessaria"];
    } else {
      this.emailAziendaRules = ["Formato Email non corretto"];
    }
  }
  validazioneTelAzienda() {
    var valid: boolean = false;
    if (this.telefonoAzienda !== "") {
      valid = /[0-9]{8,15}$/.test(this.telefonoAzienda);
    }
    if (valid) {
      this.telRules = [true];
    } else if (this.telefonoAzienda === "") {
      this.telRules = ["Telefono Azienda necessario"];
    } else {
      this.telRules = ["Il numero di telefono non ha un formato corretto"];
    }
  }
  validazionePassword() {
    var valid: boolean = false;
    if (this.password !== "") {
      valid = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-.]).{8,}$/.test(
        this.password
      );
    }
    if (valid) {
      this.passwordRules = [true];
    } else {
      this.passwordRules = [
        "La password deve essere lunga almeno 8 caratteri, contenere almeno un carattere speciale e un numero ed essere scritta con lettere maiuscole e minuscole"
      ];
    }
  }
  validazionePIva() {
    if (this.pIva !== "") {
      this.pIvaRules = [true];
    } else {
      this.pIvaRules = ["Partita IVA necessaria"];
    }
  }
  async executeTest() {
    this.validazioneNomeAzienda();
    this.validazioneEmailAzienda();
    this.validazioneTelAzienda();
    this.validazionePassword();
    this.validazionePIva();
  }
  onSignUp() {
    this.executeTest().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        // var token: string;
        var rand = function() {
          return Math.random()
            .toString(36)
            .substr(2);
        };
        var token = function() {
          return rand() + rand();
        };
        const payload = {
          denominazione: this.nomeAzienda,
          pIva: this.pIva.trim(),
          telefono: this.telefonoAzienda,
          emailAzienda: this.emailAzienda,
          password: this.password,
          token: token()
        };
        bus.$emit("signUp", payload);
      }
    });
  }
}
